import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faRecycle, faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";

library.add(faRecycle, faMinus, faPlus);

class Settings extends Component {
  state = {
    isShowSecurity: false
  };
  reset = () => {
    this.props.history.push("/reset");
  };

  openSecurity = () => {
    this.setState({ isShowSecurity: !this.state.isShowSecurity });
  };

  render() {
    let security = "";
    let securityIcon = "";

    if (this.state.isShowSecurity) {
      security = (
        <div style={{ flex: 1 }}>
          <button onClick={this.reset} style={styles.button}>
            Change Password
          </button>
        </div>
      );
      securityIcon = <FontAwesomeIcon icon="minus" />;
    } else {
      security = null;
      securityIcon = <FontAwesomeIcon icon="plus" />;
    }

    return (
      <div style={styles.container}>
        <div style={styles.groupView}>
          <div style={styles.headingView} onClick={() => this.openSecurity()}>
            <p style={styles.groupHeading}>Security</p>
            <div style={styles.icon}>{securityIcon}</div>
          </div>
          {security}
        </div>
      </div>
    );
  }
}

const styles = {
  container: {
    flex: 1,
    paddingRight: 10,
    backgroundColor: "white"
  },

  groupView: {
    marginLeft: 5,
    marginRight: 15,
    marginTop: 10,
    width: "100%",
    paddingBottom: 3
  },
  groupHeading: {
    alignSelf: "center",
    fontSize: 15,
    padding: 3,
    color: "white",
    width: "70%"
  },

  headingView: {
    display: "flex",
    backgroundColor: "#999",
    flexDirection: "row"
  },

  button: {
    marginTop: 20,
    width: "50%",
    height: "40px",
    backgroundColor: "#8cab49",
    borderColor: "transparent",
    color: "white",
    alignSelf: "center",
    outline: "none"
  },
  icon: {
    color: "white",
    display: "flex",
    alignSelf: "center"
  }
};

export default withRouter(Settings);
